const DEFINED_PROVIDERS_BY_COUNTRY = {
    ko: [ "KAKAO", "NAVER", "FACEBOOK", "GOOGLE", "APPLE" ],
    en: [ "FACEBOOK", "GOOGLE", "APPLE" ],
    jp: [ "LINE", "FACEBOOK", "GOOGLE", "APPLE" ],
}

const DEFINED_PROVIDERS_BY_COUNTRY_JOIN = {
    ko: [ "KAKAO", "NAVER", "FACEBOOK", "APPLE" ],
    en: [ "FACEBOOK", "APPLE" ],
    jp: [ "LINE", "FACEBOOK", "APPLE" ],
}

const Internal_GetProviders = isMobile => ({
    GOOGLE: {
        className: "google",
        i18nKey: isMobile ? "mobile.login.google" : "web.google.signup",
        icon: isMobile ? "https://front.videomonster.com/images-u6yd72dy/mobile/login/google_icon.png" : "https://front.videomonster.com/images-u6yd72dy/web/sociallogin_rounded_google.png",
        endpoint: "/api/auth/google"
    },
    FACEBOOK: {
        className: "facebook",
        i18nKey: isMobile ? "mobile.login.facebook" : "web.facebook.signup",
        icon: isMobile ? "https://front.videomonster.com/images-u6yd72dy/mobile/login/facebook_icon.png" : "https://front.videomonster.com/images-u6yd72dy/web/sociallogin_rounded_facebook.png",
        endpoint: "/api/auth/facebook",
		i18nKey_join: 'mobile.join.facebook'
    },
    NAVER: {
        className: "naver",
        label: isMobile ? "네이버로 로그인" : "네이버 계정으로 회원가입",
        icon: isMobile ? "https://front.videomonster.com/images-u6yd72dy/mobile/login/naver_icon.png" : "https://front.videomonster.com/images-u6yd72dy/web/sociallogin_rounded_naver.svg",
        endpoint: "/api/auth/naver",
		i18nKey_join: 'mobile.join.naver'
    },
    APPLE: {
        className: "apple",
        i18nKey: isMobile ? "mobile.login.apple" : "web.apple.signup",
        icon: isMobile ? "https://front.videomonster.com/images-u6yd72dy/mobile/login/apple_icon_w.png" : "https://front.videomonster.com/images-u6yd72dy/web/sociallogin_rounded_apple.svg",
        darkicon: "https://front.videomonster.com/images-u6yd72dy/mobile/login/apple_icon_w.png",
        endpoint: "/api/auth/apple",
        isHideDivider: true,
		i18nKey_join: 'mobile.join.apple'
    },
    LINE: {
        className: "line",
        i18nKey: isMobile ? "mobile.login.line" : "web.line.signup",
        icon: isMobile ? "https://front.videomonster.com/images-u6yd72dy/mobile/login/line_icon.png" : "https://front.videomonster.com/images-u6yd72dy/web/line_icon.png",
        endpoint: "/api/auth/line",
		i18nKey_join: 'mobile.join.line'
    },
    KAKAO: {
        className: "kakao",
        label: isMobile ? "카카오로 로그인" : "카카오 계정으로 회원가입",
        icon: isMobile ? "https://front.videomonster.com/images-u6yd72dy/mobile/login/kakao_icon.png" : "https://front.videomonster.com/images-u6yd72dy/web/sociallogin_rounded_kakao.png",
        endpoint: "/api/auth/kakao",
        label_join: '카카오로 회원가입',
		i18nKey_join: '카카오로 회원가입'
    },
    ZALO: {
        className: "zalo",
        label: isMobile ? "Đăng nhập bằng Zalo" : "Đăng ký bằng Zalo",
        icon: isMobile ? "https://front.videomonster.com/images-u6yd72dy/mobile/login/zalo_icon.png" : "https://front.videomonster.com/images-u6yd72dy/web/sociallogin_rounded_zalo.png",
        endpoint: "/api/auth/zalo",
        label_join: 'Đăng ký bằng Zalo',
		i18nKey_join: "Đăng ký bằng Zalo"
    }
})

export const GetLoginProviders = (lang, isMobile = false) => {
    const defineProviders = DEFINED_PROVIDERS_BY_COUNTRY[lang] || DEFINED_PROVIDERS_BY_COUNTRY['en']

    const loginProviders = Internal_GetProviders(isMobile)
    return defineProviders.map(key => loginProviders[key])
}

export const GetJoinProviders = (lang, isMobile = false) => {
	const defineProviders = DEFINED_PROVIDERS_BY_COUNTRY_JOIN[lang] || DEFINED_PROVIDERS_BY_COUNTRY_JOIN['en']

    const joinProviders = Internal_GetProviders(isMobile)
    return defineProviders.map(key => joinProviders[key])
}